// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
export default {
  regular: "Montserrat-Regular",
  extraBold: "Montserrat-ExtraBold",
};
